import { safeJsonResponse } from "./safeJsonResponse";

export type SupportedLocales = {
  default: string;
  locales: Array<string>;
};

export const fetchSupportedLocales = async (): Promise<SupportedLocales> => {
  const response = await fetch(`/api/content/locales`);

  // QC-016: guard against empty/invalid response bodies instead of letting
  // response.json() throw `Unexpected end of JSON input` on every page load.
  const locales = await safeJsonResponse<SupportedLocales>(response);

  if (!locales || !Array.isArray(locales.locales)) {
    throw new Error("Failed to fetch supported locales");
  }

  return locales;
};
